<div class="login-hide">
  <login></login>
</div>

<div class="ids-mt-12">
  <div class="flex flex-column align-center">
    <h2 class="ids-heading-l">Logga in</h2>
    <p class="ids-preamble ids-mt-5">Inloggning pågår, var god vänta.</p>
  </div>
</div>

<div class="flex flex-column align-center">
  <id-spinner srtext="Laddar"></id-spinner>
</div>
